import { Button, Divider, message, Modal, Spin } from "antd";
import React, { useEffect, useState } from "react";
import { RiFileExcel2Fill } from "react-icons/ri";
import { InboxOutlined } from "@ant-design/icons";
import { Upload } from "antd";
import * as XLSX from "xlsx";
import { post } from "../../../apiService";
import Dragger from "antd/es/upload/Dragger";
import moment from "moment";

export default function ImportUser({ validData, column }) {
  const [open, setOpen] = useState(false);
  const [fileUploaded, setFileUploaded] = useState(null);
  const [jsonData, setJsonData] = useState([]);
  const [fileList, setFiledList] = useState([]);
  const [msqText, setMesgText] = useState([]);
  const [loading, setLoading] = useState(false);
  const showModal = () => {
    setOpen(true);
  };

  const handleCancel = () => {
    setOpen(false);
  };

  const props = {
    className: "custom-upload",
    name: "file",
    fileList: fileList,
    accept: ".xlsx", // Corrected spelling from accespt to accept and lowercase xlsx
    action: "https://660d2bd96ddfa2943b33731c.mockapi.io/api/upload",
    multiple: false, // Restrict to one file
    onChange(info) {
      setFiledList([info.file]);
      setFileUploaded(info.file?.originFileObj);
    },
    onDrop(e) {
      console.log("Dropped files", e.dataTransfer.files);
      setFileUploaded(e.dataTransfer.files[0]?.originFileObj);
    },
  };

  useEffect(() => {
    if (!fileUploaded) return;

    const dbounce = setTimeout(() => {
      const reader = new FileReader();

      // Function to read file content
      reader.onload = (e) => {
        const data = new Uint8Array(e.target.result);
        const workbook = XLSX.read(data, { type: "array" });

        // Assuming you want to read the first sheet
        const sheetName = workbook.SheetNames[0];
        const worksheet = workbook.Sheets[sheetName];

        // Convert sheet to JSON
        const json = XLSX.utils.sheet_to_json(worksheet).map((row) => {
          const newRow = {}; // Initialize as an object for key-value mapping
          const missingKeys = []; // Track missing keys for error handling

          Object.entries(row).forEach(([key, value]) => {
            const cleanKey = key.trim(); // Trim spaces from the key

            if (validData.includes(cleanKey)) {
              const columnEntry = column.find((val) => val.title === cleanKey);

              if (columnEntry) {
                const cleanKeyFound = columnEntry.key;
                if (cleanKeyFound === "dob") {
                  const excelDate = value; // Date value from Excel
                  const jsDate =
                    typeof excelDate === "number"
                      ? new Date((excelDate - 25569) * 86400 * 1000) // Convert Excel serial date to JS date
                      : new Date(value); // Use as-is if already a date

                  newRow[cleanKeyFound] = moment(jsDate).format("YYYY-MM-DD"); // Format the date
                } else {
                  newRow[cleanKeyFound] = value; // Assign value directly for non-date fields
                }
              }
            } else {
              if (!missingKeys.includes(cleanKey)) {
                missingKeys.push(cleanKey);
              }
            }
          });

          // Update message state with missing keys
          if (missingKeys.length > 0) {
            setMesgText((prev) => [...new Set([...prev, ...missingKeys])]);
          }

          return newRow;
        });

        setJsonData(json); // Store the formatted JSON data in state
      };

      reader.readAsArrayBuffer(fileUploaded); // Read the file as ArrayBuffer
    }, 300);

    return () => clearTimeout(dbounce);
  }, [fileUploaded]);

  const formSubmit = async () => {
    if (jsonData.length > 0) {
      try {
        setLoading(true);
        const formData = new FormData();
        formData.append("action", "create_multi_user");
        formData.append("users", JSON.stringify(jsonData));
        const resp = await post("/user.php", formData);

        if (resp) {
          setLoading(false);
          message.success("User uploaded successfully.");
          setOpen(false);
          setMesgText([]);
          setFileUploaded(null);
          setFiledList([]);
          setJsonData([]);
        }
      } catch (error) {
        setLoading(false);
        console.error(error);
        message.error("Unable to upload product please try again.");
      }
    } else {
      message.error("No data found");
    }
  };

  return (
    <Spin spinning={loading}>
      <Button
        onClick={showModal}
        style={{ background: "green", color: "#fff" }}
        icon={<RiFileExcel2Fill />}
      >
        Import Users
      </Button>

      <Modal
        title="Upload Product"
        open={open}
        onCancel={handleCancel}
        okText="Upload Users"
        okButtonProps={{
          style: { backgroundColor: "var(--primeColor)", color: "white" },
        }}
        onOk={formSubmit}
        centered
      >
        <Dragger {...props}>
          <p className="ant-upload-drag-icon">
            <InboxOutlined />
          </p>
          <p className="ant-upload-text">
            Click or drag file to this area to upload
          </p>
          <p className="ant-upload-hint">Only .xlsx file support</p>
        </Dragger>
        <Divider />
        {msqText?.length > 0 && (
          <span className="text-danger">
            ({msqText.join(", ")}) - Not found columns or check spelling or
            check space in column
          </span>
        )}
      </Modal>
    </Spin>
  );
}
